import {BannerActionTypes} from 'constants/actionType';

const initialState = {
  show: false,
  severity: '',
  title: '',
  textAlign: '',
};

export default function bannerStateReducer(state = initialState, action = '') {
  switch (action.type) {
    case BannerActionTypes.SHOW_BANNER:
      return {...state, show: true, severity: action.severity, title: action.title, textAlign: action.textAlign};
    case BannerActionTypes.HIDE_BANNER:
      return initialState;
    default:
      return state;
  }
}
